
import React from 'react';
import '../../screens/privacyPolicy/privacypolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>
      <p><strong>Last updated:</strong> December 23, 2024</p>

      <section>
        <h2>1. Definitions</h2>
        <ul>
          <li><strong>Account:</strong> A unique account created for you to access our Service.</li>
          <li><strong>Company:</strong> h-cura Homeopathy Multispecialty Clinic.</li>
          <li><strong>Service:</strong> Refers to our website, accessible at <a href="https://h-cura.com/" target="_blank" rel="noopener noreferrer">https://h-cura.com/</a>.</li>
          <li><strong>Personal Data:</strong> Any information that relates to an identified or identifiable individual.</li>
          <li><strong>Cookies:</strong> Small files placed on your device by the website to store your browsing details.</li>
        </ul>
      </section>

      <section>
        <h2>2. Information We Collect</h2>
        <p>We collect the following types of data to provide and improve our service:</p>
        <ul>
          <li><strong>Personal Data:</strong> Includes name, email, phone number, address, and usage data.</li>
          <li><strong>Tracking Technologies:</strong> We use cookies and other tracking technologies to improve the user experience.</li>
        </ul>
      </section>

      <section>
        <h2>3. Use of Your Personal Data</h2>
        <p>We may use your personal information for the following purposes:</p>
        <ul>
          <li>Service improvement, account management, and contract performance.</li>
          <li>To send communication regarding updates or promotions (with your consent).</li>
        </ul>
      </section>

      <section>
        <h2>4. Sharing Your Personal Data</h2>
        <p>We may share your data with:</p>
        <ul>
          <li>Service Providers for operational support (e.g., hosting, analytics).</li>
          <li>Affiliates or partners to offer joint services.</li>
          <li>Legal compliance and protection of rights.</li>
        </ul>
      </section>

      <section>
        <h2>5. Data Retention</h2>
        <p>We will retain your personal data as long as necessary for the purposes outlined in this policy or to comply with legal obligations.</p>
      </section>

      <section>
        <h2>6. Transfer of Data</h2>
        <p>Your personal data may be processed outside of your country, including outside India. By using our service, you consent to the transfer of your data.</p>
      </section>

      <section>
        <h2>7. Your Data Protection Rights</h2>
        <p>You have the following rights regarding your personal data:</p>
        <ul>
          <li>Access and update your data by logging into your account or contacting us.</li>
          <li>Request the deletion of your data, subject to legal obligations.</li>
          <li>Opt-out of marketing communications at any time.</li>
        </ul>
      </section>

      <section>
        <h2>8. Security of Your Data</h2>
        <p>We take appropriate security measures to protect your data from unauthorized access, alteration, or destruction. However, no method of data transmission is 100% secure.</p>
      </section>

      <section>
        <h2>9. Children's Privacy</h2>
        <p>Our service is not intended for children under 13. We do not knowingly collect personal data from children.</p>
      </section>

      <section>
        <h2>10. Links to Other Websites</h2>
        <p>Our website may contain links to external sites not operated by us. We are not responsible for the privacy practices of these third-party websites.</p>
      </section>

      <section>
        <h2>11. Changes to This Privacy Policy</h2>
        <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page.</p>
      </section>

      <section>
        <h2>12. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, please contact us at:</p>
        <address>
          h-cura Homeopathy Multispecialty Clinic<br />
          No:779&780 2nd Floor, Sai Towers Building,<br />
          South, E End Main Rd, Bengaluru,<br />
          Karnataka 560069, India<br />
          Email: <a href="mailto:admin@h-cura.com">admin@h-cura.com</a><br />
          Phone: +91 8870001377
        </address>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
